export const flowFollowUsZH = {
  flowFollowUs1: '还没有未读的公告哦~',
  flowFollowUs2: '查看已读公告',
  flowFollowUs3: '你有新公告，请查看哦~',
  flowFollowUs4: '查看更多',
  flowFollowUs5: '关注我们',
  flowFollowUs6: '投诉建议',
  flowFollowUs7: '报名咨询'
}

export const flowFollowUsEN = {
  flowFollowUs1: 'There are no unread announcements yet~',
  flowFollowUs2: 'To view the published announcements',
  flowFollowUs3: 'You have a new announcement, check it out~',
  flowFollowUs4: 'More',
  flowFollowUs5: 'Follow us',
  flowFollowUs6: 'suggest',
  flowFollowUs7: 'Registration Consultation'
}



// WEBPACK FOOTER //
// ./src/assets/locale/flow/followUs.js